import React from 'react';

import {Event} from 'Services';
import ReactionApi from 'Services/Api/MainStage/Reaction';
import {asset} from 'Services/BaseHelpers';

export default class ReactionTriggers extends React.Component {
    /**
     * @var reactionTimeout
     * @type {number}
     */
    reactionTimeout = 10000;

    /**
     * @var state
     * @type {{reactionDisabled: boolean}}
     * @type {{reactions: array}}
     */
    state = {
        reactionDisabled: false,
        reactions: []
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        let reactions = Object.entries(window.base.main_stage?.reactions).map((value, key) => {
            return {
                name: value[0],
                title: value[1]
            };
        });

        this.setState({
            reactions
        });
    };

    /**
     * @method handleReaction
     * @param {string} reaction
     * @return {Promise<void>}
     */
    handleReaction = async (reaction) => {
        if (this.state.reactionDisabled) {
            return;
        }

        const request = await ReactionApi.post({
            session: this.props.sessionId
        }, {
            reaction,
        }, 'react');

        if (request.success) {
            this.setState({
                reactionDisabled: true
            });

            setTimeout(() => {
                this.setState({
                    reactionDisabled: false
                });
            }, this.reactionTimeout);

            Event.emit('reaction-posted', {
                id: request.data.data.id,
                reaction
            });
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {reactions} = this.state;

        return (
            <React.Fragment>
                {reactions.map(reaction => (
                    <div
                        onClick={() => this.handleReaction(reaction.name)}
                        key={reaction.title}
                        title={reaction.title}
                        className={`my-1 cursor-pointer ${this.state.reactionDisabled ? 'opacity-50' : ''}`}
                    >
                        <img
                            src={asset(`/images/reactions/${reaction.name}.png`)}
                            alt={reaction.title}
                            className="w-12 h-12"
                        />
                    </div>
                ))}
            </React.Fragment>
        );
    }
}
